/* eslint-disable @typescript-eslint/no-var-requires */
export const phoenixShopAdvSearchInventoryDate = require('./phoenixShopAdvSearchInventoryDate.graphql');
